import { resource, tapMemo, tapState } from "@assistant-ui/tap";
const COMPLETE_STATUS = Object.freeze({
    type: "complete",
});
export const ChainOfThoughtClient = resource(({ parts, getMessagePart, }) => {
    const [collapsed, setCollapsed] = tapState(true);
    const status = tapMemo(() => {
        const lastPart = parts[parts.length - 1];
        return lastPart?.status ?? COMPLETE_STATUS;
    }, [parts]);
    const state = tapMemo(() => ({ parts, collapsed, status }), [parts, collapsed, status]);
    return {
        state,
        methods: {
            getState: () => state,
            setCollapsed,
            part: getMessagePart,
        },
    };
});
//# sourceMappingURL=ChainOfThoughtClient.js.map